const PromotionType = {
  ALLOCATED: 1,
  NOT_ALLOCATED: 2
}
export default PromotionType
